import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify";
import axios from "axios";
import VueRouter from "vue-router";
import VueCookie from "vue-cookie";
import "vuetify/dist/vuetify.min.css";

// import components
import Admin from "./views/Admin.vue";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";

Vue.prototype.$http = axios;

Vue.use(VueRouter);
Vue.use(VueCookie);
Vue.use(Vuetify);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/",
      name: "home",
      component: Home
    }
  ]
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (document.cookie("token") == null) {
//       next({
//         path: "/login"
//       });
//     }
//   } else {
//     next();
//   }
// });

const vuetifyOptions = {
  icons: {
    iconfont: "mdiSvg"
  },
  theme: {
    light: true,
    themes: {
      light: {
        primary: "#382E2C",
        secondary: "#6A4A36",
        accent: "#1b98e0"
      },
      dark: {
        primary: "#382e2c",
      }
    }
  }
};

new Vue({
  el: "#app",
  router: router,
  vuetify: new Vuetify(vuetifyOptions),
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js